// cart-drawer.js — compacted 27-10-2026 (indentation/comments stripped to fit the theme API upload).
// 27-10: engraving is $0 with a Lahat piece; window.PHL_ENGR (snippets/phl-cart-layout.liquid) gives the $0 "Lahat" variant id + Lahat handles.
class CartDrawer {
constructor(selector = '#CartDrawer') {
this.drawer = typeof selector === 'string' ? document.querySelector(selector) : selector;
if (!this.drawer) return console.warn('[CartDrawer] Drawer not found');
this.overlay = document.querySelector('#CartDrawer-Overlay');
this.items = this.drawer.querySelector('#CartDrawer-Items');
this.subtotal = this.drawer.querySelector('#CartDrawer-Subtotal');
this.loading = this.drawer;
this._isOpen = false;
this._isBusy = false;
this._refreshing = false;
this._pendingRefresh = false;
this.debouncedQtyUpdate = this.debounce(400);
this._bindStaticEvents();
this._initCartTrigger();
}
debounce(wait = 400) {
const timers = {};
return (key, fn) => {
clearTimeout(timers[key]);
timers[key] = setTimeout(() => {
fn();
delete timers[key];
}, wait);
};
}
open() {
if (this._isOpen) return;
this._isOpen = true;
this.drawer.classList.add('is-open');
document.body.style.overflow = 'hidden';
this.drawer.setAttribute('aria-hidden', 'false');
this._focusFirst();
this._emit('cart:opened');
}
close() {
if (!this._isOpen) return;
this._isOpen = false;
this.drawer.classList.remove('is-open');
document.body.style.overflow = '';
this._emit('cart:closed');
}
async addItem(id, quantity = 1, properties = {}) {
const cart = await this._request('/cart/add.js', {
items: [{
id,
quantity,
properties
}],
sections: 'cart-drawer',
sections_url: window.location.pathname
});
if (!cart) return cart;
const html = cart.sections?.['cart-drawer'];
if (!html || !this._renderDrawer(html)) await this.refresh();
return cart;
}
async updateItem(key, quantity) {
return this._request('/cart/change.js', {
id: key,
quantity
});
}
async removeItem(key) {
const cart = await this.updateItem(key, 0);
if (cart) await this.refresh();
return cart;
}
_clearEngravingText() {
const textarea = this.drawer.querySelector('#engraving-text');
if (textarea && textarea.value) {
textarea.value = '';
textarea.dispatchEvent(new Event('input', { bubbles: true }));
}
}
_engravingIds(checkbox) {
const std = Number(checkbox.dataset.variantId);
const cfg = window.PHL_ENGR || {};
const lahat = Number(cfg.lahat) || 0;
const handles = cfg.handles || [];
const hasLahat = !!lahat && Array.from(this.drawer.querySelectorAll('.cart-item a.cart-item__title'))
.some((a) => handles.includes((a.pathname || '').split('/').pop()));
return { want: hasLahat ? lahat : std, other: hasLahat ? std : lahat, hasLahat };
}
_engravingPrice(checkbox, hasLahat) {
const price = checkbox.closest('.engraving')?.querySelector('.price');
if (!price) return;
if (price.dataset.std === undefined) price.dataset.std = price.textContent.trim();
const std = price.dataset.std;
if (hasLahat) {
const s = document.createElement('s');
s.textContent = std;
price.replaceChildren(s, document.createTextNode(' ' + std.replace(/[\d.,\s]+$/, '0')));
} else {
price.textContent = std;
}
}
_syncEngravingCheckbox() {
const checkbox = this.drawer.querySelector('#engraving-checkbox');
if (!checkbox) return;
const { want: id, other, hasLahat } = this._engravingIds(checkbox);
if (!id) return;
this._engravingPrice(checkbox, hasLahat);
const existingKey = this.drawer.querySelector(`.cart-item[data-id="${id}"]`)?.dataset.key;
const staleKey = other ? this.drawer.querySelector(`.cart-item[data-id="${other}"]`)?.dataset.key : null;
checkbox.checked = !!(existingKey || staleKey);
const details = checkbox.closest('details');
if (details) details.open = checkbox.checked;
if (!existingKey && staleKey) {
if (this._engravingSwapping) return;
this._engravingSwapping = true;
(async () => {
try {
const removed = await this.updateItem(staleKey, 0);
if (removed) await this.addItem(id, 1);
else await this.refresh();
} finally {
this._engravingSwapping = false;
}
})();
return;
}
if (!existingKey) this._clearEngravingText();
}
_updateQtyButtons() {
this.drawer.querySelectorAll('.cart-item').forEach((item) => {
const input   = item.querySelector('.cart-item__qty');
const plusBtn = item.querySelector('.cart-item__qty-btn.plus');
if (!input || !plusBtn) return;
const max = parseInt(input.getAttribute('max'), 10);
const val = parseInt(input.value, 10);
if (!isNaN(max)) {
if (val >= max) {
plusBtn.setAttribute('disabled', 'disabled');
} else {
plusBtn.removeAttribute('disabled');
}
}
});
}
async refresh() {
if (this._refreshing) {
this._pendingRefresh = true;
return;
}
this._refreshing = true;
this._setLoading(true);
try {
const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
if (res.status === 429) {
const retryAfter = Number(res.headers.get('Retry-After') || 2);
console.warn(`[CartDrawer] Rate limited. Retrying in ${retryAfter}s`);
await this._sleep(retryAfter * 1000);
this._refreshing = false;
return this.refresh();
}
if (!res.ok) {
console.error(`[CartDrawer] Refresh failed with status ${res.status}`);
return;
}
const data = await res.json();
const html = data['cart-drawer'];
if (!html) return;
this._renderDrawer(html);
} catch (e) {
console.error('[CartDrawer] Refresh failed', e.message);
} finally {
this._refreshing = false;
this._setLoading(false);
if (this._pendingRefresh) {
this._pendingRefresh = false;
this.refresh();
}
}
}
_renderDrawer(html) {
const doc = new DOMParser().parseFromString(html, 'text/html');
const newDrawer = doc.querySelector('#CartDrawer');
if (!newDrawer) return false;
const newItems = newDrawer.querySelector('#CartDrawer-Items');
const newSubtotal = newDrawer.querySelector('#CartDrawer-Subtotal');
if (this.items && newItems) this.items.innerHTML = newItems.innerHTML;
if (this.subtotal && newSubtotal) this.subtotal.textContent = newSubtotal.textContent;
if (!this.items || !newItems) {
this.drawer.innerHTML = newDrawer.innerHTML;
this.items = this.drawer.querySelector('#CartDrawer-Items');
this.subtotal = this.drawer.querySelector('#CartDrawer-Subtotal');
}
const parsedCount = newDrawer.querySelector('#CartDrawer-Item-count')?.dataset.itemsCount;
this._updateNavCount(parsedCount);
this.handleEngraving();
this._handleGiftNote();
this._bindUpsell();
this._handleAddonAccordions();
this._updateQtyButtons();
this._syncEngravingCheckbox();
return true;
}
handleEngraving() {
const checkbox = this.drawer.querySelector('#engraving-checkbox');
if (!checkbox || checkbox._engravingBound) return;
checkbox._engravingBound = true;
const details = checkbox.closest('details');
checkbox.addEventListener('change', async () => {
const { want: id, other } = this._engravingIds(checkbox);
if (!id || checkbox._engravingBusy) return;
checkbox._engravingBusy = true;
checkbox.disabled = true;
const wantChecked = checkbox.checked;
if (details) details.open = wantChecked;
const key = this.drawer.querySelector(`.cart-item[data-id="${id}"]`)?.dataset.key
|| (other && this.drawer.querySelector(`.cart-item[data-id="${other}"]`)?.dataset.key);
try {
if (wantChecked && !key) {
const result = await this.addItem(id, 1);
if (!result) {
checkbox.checked = false;
if (details) details.open = false;
this._clearEngravingText();
}
} else if (!wantChecked && key) {
this._clearEngravingText();
const result = await this.removeItem(key);
if (!result) {
checkbox.checked = true;
if (details) details.open = true;
}
}
} finally {
checkbox.disabled = false;
checkbox._engravingBusy = false;
}
});
this._syncEngravingCheckbox();
const ids = this._engravingIds(checkbox);
const existingKey = [ids.want, ids.other].filter(Boolean)
.map((x) => this.drawer.querySelector(`.cart-item[data-id="${x}"]`)?.dataset.key).find(Boolean);
if (existingKey) {
checkbox.checked = true;
if (details) details.open = true;
} else {
this._clearEngravingText();
}
}
_handleGiftNote() {
const checkbox = this.drawer.querySelector('[name="attributes[gift_note]"]');
if (!checkbox || checkbox._giftNoteBound) return;
checkbox._giftNoteBound = true;
const details = checkbox.closest('details');
const textarea = this.drawer.querySelector('#gift-note-text');
checkbox.addEventListener('change', () => {
if (details) details.open = checkbox.checked;
if (!checkbox.checked && textarea) textarea.value = '';
});
}
_handleAddonAccordions() {
this.drawer.querySelectorAll('.cart-addon-details summary label').forEach((label) => {
if (label._accordionBound) return;
label._accordionBound = true;
label.addEventListener('click', (e) => e.stopPropagation());
});
}
_bindUpsell() {
this.drawer.querySelectorAll('[data-action="upsell-add"]').forEach((btn) => {
if (btn._upsellBound) return;
btn._upsellBound = true;
btn.addEventListener('click', async () => {
const variantId = Number(btn.dataset.variantId);
if (!variantId) return console.warn('[CartDrawer] Upsell missing data-variant-id');
btn.disabled = true;
await this.addItem(variantId, 1);
btn.disabled = false;
});
});
}
_updateNavCount(count) {
const el = document.querySelector('.cart-quantity-text.is-nav');
if (!el) return;
const icon = el.parentElement.querySelector('.menu-icon');
if (count > 0) {
el.textContent = count;
icon?.classList.add('is-orange');
} else {
el.textContent = '';
icon?.classList.remove('is-orange');
}
}
_bindStaticEvents() {
this.overlay?.addEventListener('click', () => this.close());
document.addEventListener('keyup', (e) => {
if (e.code === 'Escape' && this._isOpen) this.close();
});
this.drawer.addEventListener('click', (e) => {
if (e.target.closest('.cart-drawer__close')) {
this.close();
return;
}
const minusBtn = e.target.closest('.cart-item__qty-btn.minus');
const plusBtn = e.target.closest('.cart-item__qty-btn.plus');
if (minusBtn || plusBtn) {
const wrap = e.target.closest('.cart-item__quantity-wrap');
const input = wrap?.querySelector('.cart-item__qty');
if (!input) return;
const key = input.dataset.qty;
let value = parseInt(input.value, 10) || 1;
if (minusBtn) {
value -= 1;
if (value <= 0) {
this.removeItem(key);
return;
}
}
if (plusBtn) value += 1;
input.value = value;
this.debouncedQtyUpdate(key, async () => {
const cart = await this._request('/cart/change.js', {
id: key,
quantity: value
});
if (!cart) {
await this.refresh();
return;
}
const actualItem = cart.items?.find(item => item.key === key);
const actualQty  = actualItem?.quantity;
if (actualQty !== undefined && actualQty !== value) {
input.value = actualQty;
}
await this.refresh();
});
}
});
this.drawer.addEventListener('change', (e) => {
if (!e.target.matches('.cart-item__qty')) return;
const input = e.target;
const key = input.dataset.qty;
let value = parseInt(input.value, 10);
if (!value || value < 1) value = 1;
input.value = value;
this.updateItem(key, value).then(async (cart) => {
if (!cart) {
await this.refresh();
return;
}
const actualItem = cart.items?.find(item => item.key === key);
const actualQty  = actualItem?.quantity;
if (actualQty !== undefined && actualQty !== value) {
input.value = actualQty;
}
await this.refresh();
});
});
}
_initCartTrigger() {
const icon = document.querySelector('.navbar_menu-button-wrapper.is-cart');
if (!icon) return;
icon.addEventListener('click', (e) => {
e.preventDefault();
this.open();
});
}
_showToastOnce(msg) {
const now = Date.now();
if (this._lastToastMsg === msg && now - this._lastToastTime < 1000) {
return;
}
this._lastToastMsg = msg;
this._lastToastTime = now;
CartToast.error(msg);
}
async _request(endpoint, body) {
if (this._isBusy) return null;
this._isBusy = true;
this._setLoading(true);
try {
const root = window.Shopify?.routes?.root ?? '/';
const res = await fetch(root + endpoint.replace(/^\//, ''), {
method: 'POST',
headers: {
'Content-Type': 'application/json',
Accept: 'application/json'
},
body: JSON.stringify(body)
});
if (res.status === 429) {
this._showToastOnce('Too many requests. Please wait a moment and try again.');
return null;
}
const data = await res.json();
if (!res.ok) {
const msg = data.description || data.message || 'Cart request failed';
this._showToastOnce(msg);
return null;
}
this._emit('cart:updated', data);
return data;
} catch (e) {
this._showToastOnce("Network Error — please try again.");
return null;
} finally {
this._isBusy = false;
this._setLoading(false);
}
}
_setLoading(state) {
this.loading?.classList.toggle('is-loading', state);
}
_focusFirst() {
const el = this.drawer.querySelector(
'button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])'
);
el?.focus();
}
_emit(name, detail = {}) {
document.dispatchEvent(new CustomEvent(name, {
bubbles: true,
detail
}));
}
_sleep(ms) {
return new Promise(resolve => setTimeout(resolve, ms));
}
}
document.addEventListener('DOMContentLoaded', () => {
window.cartDrawer = new CartDrawer('#CartDrawer');
window.cartDrawer.handleEngraving();
window.cartDrawer._handleGiftNote();
window.cartDrawer._handleAddonAccordions();
window.cartDrawer._bindUpsell();
});